import Vue from 'vue';
import Router from 'vue-router';
import LoginForm from './components/Login.vue';
import DashboardLayout from './components/Dashboard.vue';
import AdminDashboardView from './views/admin/AdminDashboardView.vue';
import ProductAdminView from './views/admin/ProductAdminView.vue';
import CategoryAdminView from './views/admin/CategoryAdminView.vue';
import InventoryManagementView from './views/admin/InventoryManagementView.vue';
import CashClosureView from './views/admin/CashClosureView.vue';
import ClientAdminView from './views/admin/ClientAdminView.vue';
import SalesTicketsView from './views/admin/SalesTicketsView.vue';
import ReportsSalesSectionView from './views/admin/reports/ReportsSalesSectionView.vue';
import ReportsInventorySectionView from './views/admin/reports/ReportsInventorySectionView.vue';
import ReportsClientsSectionView from './views/admin/reports/ReportsClientsSectionView.vue';
import InventorySalesProductsReportView from './views/admin/reports/InventorySalesProductsReportView.vue';
import InventoryExistenceReportView from './views/admin/reports/InventoryExistenceReportView.vue';
import SalesSummaryReportView from './views/admin/reports/SalesSummaryReportView.vue';
import SalesTicketsReportView from './views/admin/reports/SalesTicketsReportView.vue';

Vue.use(Router);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginForm
  },
  {
    // Ruta layout principal para usuarios autenticados
    path: '/dashboard',
    component: DashboardLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/admin/dashboard'
      },
      {
        path: '/admin/dashboard',
        name: 'AdminDashboard',
        component: AdminDashboardView
      },
      {
        path: '/admin/cash-closure',
        name: 'AdminCashClosure',
        component: CashClosureView
      },
      {
        path: '/admin/sales',
        name: 'AdminSales',
        component: SalesTicketsView
      },
      {
        path: '/admin/products',
        name: 'AdminProducts',
        component: ProductAdminView
      },
      {
        path: '/admin/categories',
        name: 'AdminCategories',
        component: CategoryAdminView
      },
      {
        path: '/admin/inventory',
        name: 'AdminInventory',
        component: InventoryManagementView
      },
      {
        path: '/admin/clients',
        name: 'AdminClients',
        component: ClientAdminView
      },
      {
        path: '/admin/clients/new',
        name: 'AdminClientCreate',
        component: () => import('./views/admin/ClientFormView.vue')
      },
      {
        path: '/admin/clients/edit/:id',
        name: 'AdminClientEdit',
        component: () => import('./views/admin/ClientFormView.vue')
      },
      {
        path: '/admin/products/new',
        name: 'AdminProductCreate',
        component: () => import('./views/admin/ProductFormView.vue')
      },
      {
        path: '/admin/products/edit/:id',
        name: 'AdminProductEdit',
        component: () => import('./views/admin/ProductFormView.vue')
      },
      {
        path: '/admin/users',
        name: 'AdminUsers',
        component: () => import(/* webpackChunkName: "admin-users" */ './components/admin/UserAdmin.vue')
      },
      {
        path: '/admin/reports',
        redirect: '/admin/reports/inventory'
      },
      {
        path: '/admin/reports/sales',
        name: 'AdminReportsSales',
        component: ReportsSalesSectionView
      },
      {
        path: '/admin/reports/sales/summary',
        name: 'AdminReportSalesSummary',
        component: SalesSummaryReportView
      },
      {
        path: '/admin/reports/sales/tickets',
        name: 'AdminReportSalesTickets',
        component: SalesTicketsReportView
      },
      {
        path: '/admin/reports/inventory',
        name: 'AdminReportsInventory',
        component: ReportsInventorySectionView
      },
      {
        path: '/admin/reports/clients',
        name: 'AdminReportsClients',
        component: ReportsClientsSectionView
      },
      {
        path: '/admin/reports/inventory/products-sales',
        name: 'AdminReportInventorySalesProducts',
        component: InventorySalesProductsReportView
      },
      {
        path: '/admin/reports/inventory/existence',
        name: 'AdminReportInventoryExistence',
        component: InventoryExistenceReportView
      },
    ]
  },
  {
    // Redirección para la ruta raíz
    path: '/',
    redirect: '/dashboard'
  },
  {
    // Captura cualquier ruta no definida
    path: '*',
    redirect: () => {
      const token = localStorage.getItem('token');
      return token ? '/dashboard' : '/login';
    }
  }
];

const router = new Router({
  mode: 'history',
  routes
});

// Protección de rutas simplificada
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  
  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    // Si la ruta requiere autenticación y no hay token, redirige a /login
    next('/login');
  } else if (to.path === '/login' && token) {
    // Si el usuario intenta acceder a /login pero ya está autenticado, redirige a /dashboard
    next('/dashboard');
  }
  else {
    // En cualquier otro caso, permite la navegación
    next();
  }
});

export default router; 